import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class PropertyNotUsedDetail {
    constructor(doc)
    {
		this.label = null
		this.additionalPropertyAnalyzedNotUsedText = null
		this.considerationRequestedIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.additionalPropertyAnalyzedNotUsedText = x.getStringElement(doc, "./ns:AdditionalPropertyAnalyzedNotUsedText");
		this.considerationRequestedIndicator = x.getBooleanElement(doc, "./ns:ConsiderationRequestedIndicator");
   }
}

export class PropertyNotUsedReason {
    constructor(doc)
    {
		this.label = null
		this.reasonPropertyNotUsedType = null
		this.reasonPropertyNotUsedTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.reasonPropertyNotUsedType = x.getStringElement(doc, "./ns:ReasonPropertyNotUsedType");
		this.reasonPropertyNotUsedTypeOtherDescription = x.getStringElement(doc, "./ns:ReasonPropertyNotUsedTypeOtherDescription");
   }

	 GetReason() {
		return h.descriptionOrOther(this.reasonPropertyNotUsedType, this.reasonPropertyNotUsedTypeOtherDescription);
	 }
}

export class PropertyNotUsed {
    constructor(doc)
    {
		this.label = null
		this.propertyNotUsedDetail = null
		this.propertyNotUsedReasons = []
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:PROPERTY_NOT_USED_DETAIL");
		if (node !== null)
				this.propertyNotUsedDetail = new PropertyNotUsedDetail(node);
		nodes = x.selectNodes(doc, "./ns:PROPERTY_NOT_USED_REASONS/ns:PROPERTY_NOT_USED_REASON");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.propertyNotUsedReasons.push(new PropertyNotUsedReason(xn));
			});
		}
	}

	GetNotUsedReasons() {
		let reasons = "";
		for (let reason of this.propertyNotUsedReasons) {
			reasons = h.addWithNewline(reasons, reason.GetReason());
		}
		return reasons;
	}
}

